<template>
  <b-card class="tabs__style">
    <b-tabs
      pills
      vertical
      nav-wrapper-class="nav-vertical"
    >
      <b-tab
        active
        lazy
        :title="$t('reference.material')"
      >
        <b-card-text>
          <materials />
        </b-card-text>
      </b-tab>

      <b-tab
        lazy
        :title="$t('reference.instrument')"
      >
        <b-card-text>
          <instruments />
        </b-card-text>
      </b-tab>


      <b-tab
        lazy
        :title="$t('reference.units')"
      >
        <b-card-text>
          <units />
        </b-card-text>
      </b-tab>

      <b-tab
        lazy
        :title="$t('objects__ob')"
      >
        <b-card-text>
          <objects />
        </b-card-text>
      </b-tab>

      <b-tab
        lazy
        :title="$t('warehouses')"
      >
        <b-card-text>
          <warehouse />
        </b-card-text>
      </b-tab>

      <b-tab
        lazy
        :title="$t('money_accounts')"
      >
        <b-card-text>
          <moneyReport />
        </b-card-text>
      </b-tab>
      
      
      <b-tab
        lazy
        :title="$t('brigades')"
      >
        <b-card-text>
          <brigades />
        </b-card-text>
      </b-tab>
      
      
      <b-tab
        lazy
        :title="$t('transports')"
      >
        <b-card-text>
          <transports />
        </b-card-text>
      </b-tab>


      <b-tab
        lazy
        :title="$t('place_of_work')"
      >
        <b-card-text>
          <placeOfWork />
        </b-card-text>
      </b-tab>

      <b-tab
        lazy
        :title="$t('job_type')"
      >
        <b-card-text>
          <works />
        </b-card-text>
      </b-tab>




      

      <!-- <b-tab
        lazy
        title="Ввод остатков"
      >
        <b-card-text>
          <entering-balances />
        </b-card-text>
      </b-tab> -->
    </b-tabs>
  </b-card>
</template>

<script>
import { BTabs, BTab, BCardText, BCard } from "bootstrap-vue";
import materials from "./materials/index.vue";
import units from "./units/index.vue";
import moneyReport from "./moneyReport/index.vue";
import objects from "./objects/index.vue";
import warehouse from "./warehouse/index.vue";
import instruments from "./instruments/index.vue";
import brigades from "./brigades/index.vue";
import transports from "./transports/index.vue";
import placeOfWork from "./placeOfWork/index.vue";
import works from "./works/index.vue";
import loader from "@/mixins/loader";
// import enteringBalances from './enteringBalances/index.vue'

export default {
  name: "Index",
  mixins: [loader],
  components: {
    BTabs,
    BTab,
    BCardText,
    BCard,
    materials,
    units,
    moneyReport,
    objects,
    warehouse,
    brigades,
    transports,
    instruments,
    placeOfWork,
    works,
    // enteringBalances,
  },

  async mounted() {
    // await this.$_loaderStart();
  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
};
</script>

<style>
.tabs__style .nav-vertical ul li a {
  display: flex;
  align-items: center;
  justify-content: start;
}

/* .tabs__style ul:nth-child(1)::after {
  content: "";
  position: absolute;
  border-right: 1px solid #cccccc54;
  border-radius: 0;
  top: 4px;
  height: 100%;
  right: 1px;
} */
</style>
